import * as History from 'history';
import { IWithContextProps, IWithContextRef, withContext } from '@tock/coretypes';
import { Route, Switch } from 'react-router-dom';
import { TockCookieName } from '@tock/shared/constants/browser-storage/TockCookies';
import { loadable } from 'utils/loadable';
import { setCookie } from '@tock/shared/utils/cookieUtils';
import BaseComponent from '@tock/shared/components/BaseComponent';
import _ from 'lodash';
import connect, { DefaultConnectProps } from '@tock/shared/utils/connect';
import queryString from '@tock/query-string';

const ReserveWithGoogleRedirectRoute = loadable(
  () => import('routes/business/syndicate-flow/ReserveWithGoogleRedirectRoute')
);

const SyndicateIndexRoute = loadable(
  () => import('routes/business/syndicate-flow/SyndicateIndexRoute')
);

interface Props extends DefaultConnectProps, IWithContextProps {
  history: History.History;
  location: History.Location;
}

class SyndicatedRoute extends BaseComponent<Props> {
  componentDidMount() {
    const { actions, location } = this.props;
    const queryParams = queryString.parse(location.search);
    // TODO: Currently, the value of the syndicate string does not matter. Consider removing its usage entirely.
    // Application.tsx checks for its existence and then sets customized themes based on styles provided as query parameters.
    const syndicate = queryParams.syndicate
      ? queryParams.syndicate
      : 'PLACEHOLDER_SYNDICATE_STRING';
    actions.syndicate.setSyndicate(syndicate);
    // Set a cookie so that we can tell it comes from the LEYE app and that we should use colors
    setCookie(TockCookieName.SYNDICATE, syndicate);
    // Saves the colors in the local storage

    const query = queryString.parse(location.search);
    const background_base = query.theme_background_base;
    const brand_muted = query.theme_brand_muted;
    const brand_primary = query.theme_brand_primary;
    const font = query.theme_font;
    if (!_.isEmpty(background_base) && !_.isEmpty(brand_muted) && !_.isEmpty(brand_primary)) {
      actions.theme.setColorTheme(background_base, brand_muted, brand_primary);
    }
    if (font === 'system') {
      actions.theme.setFontTheme('system');
    }
  }

  render() {
    const {
      context: { isFeatureEnabled },
    } = this.props;
    const isModernSyndicateRouteEnabled = isFeatureEnabled('ENABLE_MODERN_SYNDICATE_ROUTE');

    return (
      <Switch>
        {isModernSyndicateRouteEnabled && (
          <Route
            path={'/:businessDomain/syndicate/reserve-with-google'}
            component={ReserveWithGoogleRedirectRoute}
          />
        )}
        <Route component={SyndicateIndexRoute} />
      </Switch>
    );
  }
}

export default connect<IWithContextRef, DefaultConnectProps & Props>(withContext(SyndicatedRoute), [
  'app',
  'toast',
]);
